BoardListSidebarItemView = require 'views/boards-sidebar/board-list-sidebar-item-view'
BoardsSidebarBoardsView = require 'views/boards-sidebar/boards-sidebar-boards-view'
SidebarState = require 'view-models/sidebar-state'
Util = require 'lib/util'
_ = require 'underscore'
f = require 'effing'
template = require 'views/templates/boards_sidebar_filtered_boards'

module.exports = class BoardsSidebarFilteredBoardsView extends BoardsSidebarBoardsView
  initialize: ({ searchText }) ->
    @searchText = searchText
      .map (text) -> text.toLowerCase().trim()

    @subscribe @searchText, @renderResults

    @makeDebouncedMethods 'renderResults'
    @listenTo @model.boardList, 'add remove reset change:idOrganization',
      @renderResultsDebounced
    @listenTo SidebarState, 'change:idRecentBoards',
      @renderResultsDebounced
    @listenTo @model.boardStarList, 'add remove reset', ->
      @renderResultsDebounced

  renderOnce: ->
    @$el.html template()

    @renderResults()

    @

  renderResults: ->
    $container = @$('.js-board-results')

    $container.empty()

    for board in @getBoardsForTerm(@searchText.get())
      @appendSubview(@subview(BoardListSidebarItemView, board, { showOrgName: true, sectionName: "Filtered Boards" }), $container)
    Util.selectMenuItem(@$('.sidebar-boards-list'), 'li', @$('.sidebar-boards-list li:first'))

    @

  getBoardsForTerm: (term) ->
    idBoardsStarred = @model.boardStarList.getBoardIds()
    idBoardsRecent = SidebarState.getRecentBoards()

    isMatch = Util.buildFuzzyMatcher(term)
    _.chain @model.boardList.models
      .union @model.boardStarList.getBoards()
      .union @modelCache.get('Board', idBoardsRecent)
      .compact()
      .filter (board) -> isMatch(board.get 'name')
      .filter (board) -> board.isOpen()
      .value()
      .sort (a, b) ->
        if a.id in idBoardsStarred && b.id !in idBoardsStarred
          -1
        else if b.id in idBoardsStarred && a.id !in idBoardsStarred
          1
        else if a.id in idBoardsRecent && b.id !in idBoardsRecent
          -1
        else if b.id in idBoardsRecent && a.id !in idBoardsRecent
          1
        else if a.get('name') < b.get('name')
          -1
        else if a.get('name') > b.get('name')
          1
        else
          0
      .slice(0, 7)



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-filtered-boards-view.coffee